import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useGetGeomatic, useSetClientToken } from "service/geomantic";
import { IGeomatic } from "service/geomantic/interface";
import { v4 as uuidv4 } from "uuid";
import { dayjs } from "tools/timezone";
import { getKPColor, getClassColor, getThaiMonth } from "tools/util";
import { initializeApp } from "firebase/app";
import { getToken, getMessaging, isSupported, onMessage } from "firebase/messaging";
import { vapidKey } from "config/api";
import SunVDO from "asset/vdo/sun.mp4";
import kpImage from "asset/image/kp_scale2.svg";
import classImage from "asset/image/class_scale2.svg";
import { Buffer } from "buffer";
global.Buffer = Buffer;

const localTimeZone = "Asia/Bangkok";

const firebaseConfig = {
  apiKey: "AIzaSyBoPIzd7x33JGV4mh4lTBidKA5MqGRtlvY",
  projectId: "cloud-notification-service",
  messagingSenderId: "431511619582",
  appId: "1:431511619582:web:6953e9218b83f591ff22af",
};

const clientID = Cookies.get("client_id") ?? uuidv4();
const fcmToken = Cookies.get("fcm_token") ?? "";

const PrestoSolarFlare = () => {
  const [token, setToken] = useState(fcmToken);
  const [current, setCurrent] = useState<IGeomatic>({
    preto_alert: {
      physical_measure_scale: 0,
      date: "",
      effect: "",
      scale: "",
    },
    solar_flare_alert: {
      physical_measure_scale: "",
      date: "",
      effect: "",
      scale: "",
    },
  });

  const FCM = async () => {
    const isSupport = await isSupported();
    console.log("isSupport", isSupport);

    if (isSupport) {
      const app = initializeApp(firebaseConfig);
      const messaging = getMessaging(app);

      if (!token || token === "") {
        if (navigator && "serviceWorker" in navigator) {
          await navigator.serviceWorker.register("https://space-weather.pakgon.com/firebase-messaging-sw.js");
          const newToken = await getToken(messaging, { vapidKey });
          setToken(newToken);
          Cookies.set("fcm_token", newToken);
          Cookies.set("client_id", clientID); //FIXME if want to set expired { expires: 7 }
        }
      }
      onMessage(messaging, async (payload: any) => {
        const newData = JSON.parse(payload?.data?.message);
        if (newData[0]) {
          setCurrent(newData[0]);
        }
      });
    }
  };
  try {
    if (Notification && Notification.permission === "granted") {
      FCM();
    } else {
      console.log("Notification permission denied by user");
    }
  } catch (error) {
    console.log("error", error);
  }

  useSetClientToken({ token: token, device_id: clientID });
  const { data } = useGetGeomatic();
  useEffect(() => {
    setCurrent(data);
  }, [data]);

  const kpColor: string = getKPColor(current?.preto_alert?.physical_measure_scale || 0);
  const classColor: string = getClassColor(current?.solar_flare_alert?.physical_measure_scale);

  const renderLinesWithSpace = (text: string) => {
    if (text) {
      const lines = text.split("\n");
      return (
        <div>
          {lines.map((line, index) => (
            <div key={index} className="mb-[5px] text-[20px] leading-[28px] font-sans">
              {line}
            </div>
          ))}
        </div>
      );
    }
    return "";
  };

  const dateTimeString = `${current?.preto_alert?.date}:00`;
  const preto_alert_date = new Date(dateTimeString);
  const dateTimeString2 = `${current?.solar_flare_alert?.date}:00`;
  const solar_flare_alert_date = new Date(dateTimeString2);
  
  document.title = "GEOMAGNETIC STORM";

  return (
    <div className="items-center bg-black grid gap-0 grid-cols-2 justify-center" id="wrap">
      <video controls={false} className="h-[100vh]" muted loop itemType="video/mp4" autoPlay={true} src={SunVDO} />
      <div className="text-white ml-[-240px] relative pr-[100px] max-h-[100vh] overflow-scroll overflow-x-hidden" id="content">
        <h2 className="text-[46px] font-backman mt-5">GEOMAGNETIC STORM</h2>
        <div className="grid grid-cols-[max-content_auto] items-start gap-[30px] mb-4">
          <div className="inline-block">
            <div>
              <span className="text-[32px] font-ddin inline">New Scale Update &nbsp;: </span>{" "}
              <span className="text-[32px] font-ddin font-bold inline" style={{ color: `${kpColor}` }}>
                {current?.preto_alert?.scale}
              </span>
            </div>
            <div className="text-[165px] leading-[140px] font-moonhouse whitespace-nowrap number" style={{ color: `${kpColor}` }}>
              {current?.preto_alert?.physical_measure_scale}
              <span className="text-[44px] font-moonhouse">KP</span>
            </div>
          </div>

          <div className="pt-2 inline-block">
            <div className="text-[24px] mb-5 font-sans font-bold">
              {`${dayjs(current?.preto_alert.date).format("DD")} ${getThaiMonth(parseInt(dayjs(current?.preto_alert.date).format("M")))} ${dayjs(current?.preto_alert.date).format("BBBB")}`}
              <span className="text-[22px] ml-3 mr-2 font-normal">{dayjs(current?.preto_alert?.date).format("HH:mm")} น.</span>
              <span className="text-[22px] font-normal">({current?.preto_alert?.date && dayjs.tz(preto_alert_date, localTimeZone).utc().format("UTC+0 MMM DD, YYYY HH:mm")})</span>
            </div>
            <div>
              <div className="mb-[5px] text-[20px] leading-[28px] font-sans">Effect</div>
              {renderLinesWithSpace(current?.preto_alert?.effect)}
            </div>
          </div>
        </div>
        <div className="pb-3 mb-[30px]">
          <img src={kpImage} alt="" />
        </div>

        <h2 className="text-[46px] font-backman mb-0">SOLAR FLARE 24 HR ALERT</h2>
        <div className="grid grid-cols-[max-content_auto] items-start gap-[30px] mb-4">
          <div className="inline-block">
            <div>
              <span className="text-[32px] font-ddin inline">Class</span>
            </div>
            <div className="text-[165px] leading-[140px] font-moonhouse whitespace-nowrap number" style={{ color: `${classColor}` }}>
              {current?.solar_flare_alert?.physical_measure_scale}
            </div>
          </div>
          <div className="pt-2 inline-block">
            <div className="text-[24px] mb-5 font-sans font-bold">
              {`${dayjs(current?.solar_flare_alert.date).format("DD")} ${getThaiMonth(parseInt(dayjs(current?.solar_flare_alert.date).format("M")))} ${dayjs(current?.solar_flare_alert.date).format("BBBB")}`}
              <span className="text-[22px] ml-3 mr-2 font-normal">{dayjs(current?.solar_flare_alert?.date).format("HH:mm")} น.</span>
              <span className="text-[22px] font-normal">({current?.solar_flare_alert?.date && dayjs.tz(solar_flare_alert_date, localTimeZone).utc().format("UTC+0 MMM DD, YYYY HH:mm")})</span>
            </div>
            <div>
              <div className="mb-[5px] text-[20px] leading-[28px] font-sans">Effect</div>
              {renderLinesWithSpace(current?.solar_flare_alert?.effect)}
            </div>
          </div>
        </div>
        <div className="pt-3 pb-3">
          <div>
            <img src={classImage} alt="" />
          </div>
          <div className="text-[#999] text-[18px] text-right mt-5 pt-5">Credit : Spaceweather.com, Helmholtz-Zentrum Potsdam</div>
        </div>
      </div>
    </div>
  );
};

export default PrestoSolarFlare;
